export default {
  'blog-linesheet': {
    title: 'What Makes a Great Linesheet?',
    url: 'https://medium.com/@gravalot/what-makes-a-great-linesheet-52f5eb7943eb',
    img: '/img/icons/line/select-table.png',
  },
  'blog-pricing': {
    title: 'The Beginners Pricing Guide for Fashion Designers',
    url: 'https://medium.com/@gravalot/the-beginners-pricing-guide-for-fashion-designers-d6cedfd66538',
    img: '/img/icons/line/doughnut-chart.png',
  },
  'blog-sampling': {
    title: 'Why Pre-Production Sampling Matters in Fashion',
    url: 'https://medium.com/@gravalot/why-pre-production-sampling-matters-in-fashion-5314d85ca3b6',
    img: '/img/icons/line/connected-no-data.png',
  },
  'blog-local-i18n-sourcing': {
    title: 'Local vs International Sourcing and Manufacturing: Pros and Cons',
    url: 'https://medium.com/@gravalot/local-vs-international-sourcing-and-manufacturing-pros-and-cons-9ac7877beaf4',
    img: '/img/icons/line/many-to-many.png',
  },
  'blog-beginners-batch': {
    title: 'A Beginners Guide to Batch Manufacturing',
    url: 'https://medium.com/@gravalot/a-beginners-guide-to-batch-manufacturing-ec9c9b7e82a0',
    img: '/img/icons/line/replicate-rows.png',
  },
} as {
  [key: string]: {
    url: string;
    title: string;
    img: string;
  },
};
